import * as actionTypes from './action-types'

export const sendGAPageView = () => ({
  type: actionTypes.GA_PAGE_VIEW,
})

export const sendGAEvent = (eventCallbackName, data) => ({
  type: actionTypes.GA_SEND_EVENT,
  payload: { eventCallbackName, data },
})
